import { styled as o } from "styled-components";
import { c as r } from "./Container.utils-zmZUuN5x.js";
const n = o.div`
  ${r}
`;
export {
  n as C
};
